import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SEOHead } from '../../../components/seo/SEOHead';
import { Input } from '../../../components/ui/Input';
import { DataTable } from '../../../components/admin/DataTable';
import { Spinner } from '../../../components/ui/Card';
import { api } from '../../../lib/api';
import type { User } from '@bharat-consultancy/shared';

export default function CustomerList() {
  const [customers, setCustomers] = useState<User[]>([]);
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    const timeout = setTimeout(() => {
      api.admin.customers
        .list({ search })
        .then((res) => setCustomers(res.items))
        .catch(() => setCustomers([]))
        .finally(() => setIsLoading(false));
    }, 300); // debounce search input
    return () => clearTimeout(timeout);
  }, [search]);

  return (
    <>
      <SEOHead title="Customers — Admin" description="" canonicalPath="/admin/customers" />

      <div className="flex items-center justify-between">
        <h1 className="font-display text-2xl font-bold text-ink">Customers</h1>
      </div>

      <div className="mt-4 max-w-sm">
        <Input placeholder="Search by name, email, phone..." value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>

      <div className="mt-4">
        {isLoading ? (
          <Spinner className="h-6 w-6 text-seal-blue" />
        ) : (
          <DataTable
            columns={[
              { header: 'Name', render: (c) => c.name },
              { header: 'Email', render: (c) => c.email },
              { header: 'Phone', render: (c) => c.phone ?? '—' },
              { header: 'Joined', render: (c) => new Date(c.createdAt).toLocaleDateString('en-IN') },
            ]}
            rows={customers}
            keyExtractor={(c) => c.id}
            onRowClick={(c) => navigate(`/admin/customers/${c.id}`)}
            emptyMessage="No customers found."
          />
        )}
      </div>
    </>
  );
}
